export const compareVersions = (aVersion: string, bVersion: string, parser: (v: string) => number[]): number => {
  const parsedA = parser(aVersion)
  const parsedB = parser(bVersion)
  const l = parsedA.length > parsedB.length ? parsedA.length : parsedB.length

  for (let i = 0; i < l; i++) {
    const aPart = parsedA[i]
    const bPart = parsedB[i]
    if (aPart > bPart || (isNaN(bPart) && !isNaN(aPart) && aPart !== 0)) {
      return 1
    }
    if (bPart > aPart || (!isNaN(bPart) && bPart !== 0 && isNaN(aPart))) {
      return -1
    }
  }
  return 0
}
